import { render, staticRenderFns } from "./ClickSign.vue?vue&type=template&id=444dd889&"
import script from "./ClickSign.vue?vue&type=script&lang=js&"
export * from "./ClickSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports